const welcomePickupsId = 'welcomePickups';
const welcomePickupsBundleLink = ' https://cdn.b2b.welcomepickups.com/widget/bundle.js';

function loadWelcomePickups(callback?: () => void) {
  const existingScript = document.getElementById(welcomePickupsId);
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;

    script.src = welcomePickupsBundleLink;
    script.id = welcomePickupsId;
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };

    return () => {
      document.body.removeChild(script);
    };
  }
  if (existingScript && callback) callback();
}

export {loadWelcomePickups};
